'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buildQueryFactory = undefined;

var _buildFieldList = require('./buildFieldList');

var _buildFieldList2 = _interopRequireDefault(_buildFieldList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildQueryFactory = exports.buildQueryFactory = function buildQueryFactory(buildFieldListImpl) {
    return function (resource, type, queries, options) {
        var operationName = options.templates[type.name](resource);
        var query = queries.find(function (q) {
            return q.name === operationName;
        });

        if (!query) {
            return undefined;
        }

        var fields = void 0;
        if (type.returnsFields) {
            fields = buildFieldListImpl(resource, type, options);
        }

        return type.query(operationName, fields);
    };
};

exports.default = buildQueryFactory(_buildFieldList2.default);


//////////////////
// WEBPACK FOOTER
// ./~/aor-simple-graphql-client/lib/introspection/buildQueriesForResource/buildQuery.js
// module id = 933
// module chunks = 0